import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const synack = defineConnector({
  identifier: "synack",
  name: "Synack",
  tagLine: "Crowdsourced penetration testing",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api\\.synack\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Generate an API token",
      items: [
        {
          kind: "markdown",
          content:
            "In Synack, click your profile icon → **Settings → API → Tokens**. Specify whitelisted IP addresses and expiration date, then click **Generate**.",
        },
      ],
    },
    {
      title: "Paste your API token",
      items: [
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.synack.com/v1/users/me",
  },
});
